var Debug = require('../util/debug')('media-player-statistics');


const STATISTICS_API_ENDPOINT = 'https://message.cdn.svt.se';
const NAMESPACE = 'mediaplayerstatistics.';

const instances = new Map();

function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function uuid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

class MediaPlayerStatistics {
    constructor(fraction, api) {
        this.active = false;
        if (fraction < Math.random()) {
            return;
        }
        this.api = api;
        this.state = 'stop';
        this.stateChange = new Date().getTime();
        this.currentRate = {};

        this.session = uuid();
        this.initStatistics(api.getDuration(), api.getSrc());
        this.send = this.sendFkn.bind(this);
        this.callbacks();
    }

    initStatistics() {
        this.active = false;
        this.statistics = {
            type: 'player',
            application: {
                name: 'svtvideoplayer',
                location: window.location.href
            },
            player: {
                session: this.session,
                time: new Date().toISOString(),
                event: 'report',
                duration: undefined,
                location: undefined,
                report: {
                    counters: {stop: 0, start: 0, play: 0, pause: 0, seek: 0, buffer: 0},
                    timers: {stop: 0, start: 0, play: 0, pause: 0, seek: 0, buffer: 0},
                    rates: {},
                    errors: []
                }
            }
        };
    }

    callbacks() {
        this.api.filters.push({
            load: () => {
                this.send();
                this.initStatistics(this.api.getDuration(), this.api.getSrc());
            }
        });
        this.api.on(NAMESPACE + 'metadata', (e) => {
            this.statistics.player.duration = e.detail.contentDuration;
        });
        this.api.on(NAMESPACE + 'ready', () => {
            this.active = !this.api.data().usingChromecastModule;
        });
        window.addEventListener('unload', this.send);

        this.api.on(NAMESPACE + 'play', () => {
            this.statistics.player.location = this.api.getSrc();
            this.transition('start');
        });
        this.api.on(NAMESPACE + 'playing', () => this.transition('play'));
        this.api.on(NAMESPACE + 'pause', () => this.transition('pause'));
        this.api.on(NAMESPACE + 'seeking', () => this.transition('seek'));
        this.api.on(NAMESPACE + 'seeked', () => {
            if (this.api.isPaused()) {
                this.transition('stop');
                this.statistics.player.report.counters.stop--;
            } else {
                this.statistics.player.report.counters.play--;
            }
        });
        this.api.on(NAMESPACE + 'ended', () => this.transition('stop'));
        this.api.on(NAMESPACE + 'error', (e) => {
            if (e.detail && e.detail.isExpectedError === true) {
                return;
            }

            this.statistics.player.report.counters.error++;

            if (e.detail) {
                this.statistics.player.report.errors.push({
                    player: e.detail.player,
                    error: e.detail.name,
                    id : e.detail.id,
                    url : e.detail.url
                });
            } else {
                this.statistics.player.report.errors.push({
                    error: 'unknown'
                });
            }
        });
        this.api.on(NAMESPACE + 'bufferEmpty', () => {
            if (!this.api.isSeeking()) {
                this.transition('buffer');
            }
        });
        this.api.on(NAMESPACE + 'bitrateswitch', (ev) => {
            this.currentRate[ev.detail.mediaType] = ev.detail.bitrate;
        });
    }

    transition(to) {
        const t = new Date().getTime();
        const d = (t - this.stateChange) / 1000;
        if (this.state === 'play') {
            for (let mediaType of Object.keys(this.currentRate)) {
                if (!(mediaType in this.statistics.player.report.rates)) {
                    this.statistics.player.report.rates[mediaType] = {};
                }
                if (!(this.currentRate[mediaType] in this.statistics.player.report.rates[mediaType])) {
                    this.statistics.player.report.rates[mediaType][this.currentRate[mediaType]] = 0;
                }
                this.statistics.player.report.rates[mediaType][this.currentRate[mediaType]] += d;
            }
        }
        this.statistics.player.report.timers[this.state] += d;
        this.stateChange = t;
        this.state = to;
        this.statistics.player.report.counters[this.state]++;
    }

    sendFkn() {
        if (!this.active) {
            return;
        }
        if (this.state !== 'stop') {
            this.transition('stop');
        }
        navigator.sendBeacon(STATISTICS_API_ENDPOINT, JSON.stringify(this.statistics));
    }
}

export function create(api) {
    if (instances.has(api)) {
        Debug.warn(
            `Akamai statistics plugin was already created for this api instance and has
            not been destroyed. The previous instance may leak memory and listeners.`
        );
    }

    if ('navigator' in window && 'sendBeacon' in window.navigator) {
        instances.set(api, new MediaPlayerStatistics(1, api));
    }
}

export function destroy(api) {
    const mediaPlayerStatistics = instances.get(api);
    if (mediaPlayerStatistics) {
        api.off(NAMESPACE + 'ready');
        api.off(NAMESPACE + 'metadata');
        window.removeEventListener('unload', mediaPlayerStatistics.send);
        api.off(NAMESPACE + 'play');
        api.off(NAMESPACE + 'playing');
        api.off(NAMESPACE + 'pause');
        api.off(NAMESPACE + 'seeking');
        api.off(NAMESPACE + 'seeked');
        api.off(NAMESPACE + 'ended');
        api.off(NAMESPACE + 'error');
        api.off(NAMESPACE + 'waiting');
        api.off(NAMESPACE + 'bitrateswitch');
        api.off(NAMESPACE + 'bufferEmpty');
        // TODO: Remove the filter on load

        mediaPlayerStatistics.send();
        instances.delete(api);
    }
}



// WEBPACK FOOTER //
// ./src/js/plugins/media-player-statistics.js